import { useState } from 'react'

import { dateInputFormatter } from '../../services/helpers'

interface Props {
  value?: string
}

const DateInput: React.FC<Props> = ({ value }) => {
  const [vals, setVals] = useState(dateInputFormatter(value))

  return (
    <>
      <input
        type="date"
        name="date of birth"
        value={vals}
        onChange={(e) => {
          setVals(e.target.value)
        }}
      />
    </>
  )
}

export default DateInput
